import { useNavigate } from "react-router-dom";
import { useWindowSize } from "react-use";
import { useTranslation } from "react-i18next";

import color from "color";

import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Grid, { GridProps } from "@mui/material/Grid";

import Title from "../../components/Title";

import { useLayout } from "../../lib/hooks/useQueryBoard";
import { MUIHomeSmallButton } from "../Home";

import SvgIcon from "../../components/SvgIcon";
import BackButton from "../../components/BackButton";
import { useHeaderHeightContext } from "../../context/HeaderHeight";
import { getOptimalTextColor } from "../../bit/theme";

interface WayfindingGridProps extends GridProps {
  headerHeight: number;
  footerHeight: number;
}

export const WayfindingGrid = styled(Grid, {
  shouldForwardProp: (prop) =>
    prop !== "headerHeight" && prop !== "footerHeight",
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
})<WayfindingGridProps>(({ headerHeight, footerHeight, theme }) => ({
  marginTop: "3rem",
  // maxHeight: `calc(100vh - ${headerHeight}px - ${footerHeight}px)`,
  // overflowY: "auto",
  // WebkitOverflowScrolling: "touch",

  // "&::-webkit-scrollbar": {
  //   width: "2rem",
  // },

  // "&::-webkit-scrollbar-track": {
  //   background: theme.palette.primary.light,
  //   borderRadius: "8px",
  // },

  // "&::-webkit-scrollbar-thumb": {
  //   background: theme.palette.primary.main,
  //   borderRadius: "8px",
  // },

  "@media screen and (orientation: landscape)": {
    marginTop: "0",
  },
}));

interface WayfindinOptionButtonProps {
  bgColor?: string;
}

export const WayfindinOptionButton = styled(MUIHomeSmallButton, {
  shouldForwardProp: (prop) => prop !== "bgColor",
})<WayfindinOptionButtonProps>(({ bgColor, theme }) => {
  const background = bgColor || theme.palette.primary.main;
  const darkerBg = color(background).darken(0.2).hex();
  const textColor = getOptimalTextColor(
    theme.palette.background.default,
    background,
    theme.palette.text.primary,
  );

  return {
    backgroundColor: background,

    margin: "1rem auto 3rem",
    transition: "background-color 0.3s ease",

    "&:hover": {
      backgroundColor: darkerBg,
    },

    "&:active": {
      backgroundColor: darkerBg,
    },

    h3: {
      color: `${textColor} !important`,
    },

    svg: {
      fill: textColor,
    },
  };
});

const WayfindingOptionPage = () => {
  const { t } = useTranslation(["wayfinding"]);

  const navigate = useNavigate();

  const { height: headerHeight } = useHeaderHeightContext();
  const { width, height } = useWindowSize();

  const { multiWayfinding } = useLayout();

  return (
    <div className="d-flex align-items-center flex-column">
      <BackButton to="/" />
      <Title className="page-title home mb-5">
        <Typography variant="h1">{t("wayfinding:title")}</Typography>
      </Title>
      <WayfindingGrid
        container
        justifyContent="center"
        columnGap={4}
        headerHeight={width < height ? headerHeight : 0}
        footerHeight={width < height ? 590 : 700}
      >
        {multiWayfinding?.wayfindingOptions?.map((option, i) => (
          <WayfindinOptionButton
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            bgColor={option.colors?.background}
            onClick={() =>
              navigate(`${i}`, {
                replace: true,
              })
            }
          >
            {option.svg && <SvgIcon id={option.svg} width="6.5rem" />}
            <Typography variant="h3">{option.label}</Typography>
          </WayfindinOptionButton>
        ))}
      </WayfindingGrid>
    </div>
  );
};

export default WayfindingOptionPage;
